import { createContext, useContext } from 'react';

import { MediaStateType } from '@/hooks/useMedia';
import { Posts } from '@/models/posts';

export interface VisualsContextValue {
  selectedMinorItems: Posts.MinorItem[];
  setSelectedMinorItems: MediaStateType['setSelectedMinorItems'];
  selectedOcrAdvItems: Posts.OcrAdvImageItem[];
  setSelectedOcrAdvItems: MediaStateType['setSelectedOcrAdvItems'];
  markerItems: (Posts.MinorItem | Posts.OcrAdvImageItem | Posts.LogoItem)[];
  clearSelections: () => void;
}

const CreatorPostVisualsContext = createContext<VisualsContextValue>(
  {} as VisualsContextValue
);

interface ProviderProps {
  value: VisualsContextValue;
  children: React.ReactNode;
}

export const CreatorPostVisualsProvider = ({
  value,
  children
}: ProviderProps) => (
  <CreatorPostVisualsContext.Provider value={value}>
    {children}
  </CreatorPostVisualsContext.Provider>
);

export const useCreatorPostVisuals = () =>
  useContext(CreatorPostVisualsContext);
